export class BusAlertConf {
  id: number;
  busId: number;
  alertId: number;
  value: string;
  status: number;
  zname: string;
  zrayon: number;
  zlat: number;
  zlng: number;
  zsignIn: number;
  zsignOut: number;
  zoneCoordinates: string;
  // bus

  constructor() {
    this.id = null;
    this.busId = null;
    this.alertId = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/bus-alert-conf.ts